import { ReactNode } from 'react';

import { Box, Content, Logo, Title, Wrapper } from './Quote.styles';

export interface QuoteProps {
  altIcon?: string;
  children: ReactNode;
  className?: string;
  title?: string;
  logo?: string;
}

const Quote = ({
  altIcon,
  children,
  className,
  title,
  logo,
}: QuoteProps): JSX.Element => {
  return (
    <Wrapper className={className}>
      {title && <Title>{title}</Title>}
      {logo && (
        <Title>
          <Logo src="/logoWhite.png" alt={altIcon} />
        </Title>
      )}
      <Box>
        <Content>{children}</Content>
      </Box>
    </Wrapper>
  );
};

export default Quote;
